// Dados centrais do site. Tudo o que está marcado "POR VALIDAR" deve ser confirmado antes de publicar.
export const SITE = {
  name: "IGNIVA Design & Surface Solutions",
  legalName: "IGNIVA Design & Surface Solutions, Unipessoal Lda.",
  nif: "518865983",
  seat: "Avenida dos Congressos da Oposição Democrática, Lote 5, 4.º B, 3800-365 Aveiro, Portugal",
  url: "https://ignivadesign.pt",
  // Email público do site (confirmado). É também o destinatário dos formulários (definido no Worker).
  email: "ignivadesign@gmail.com",
  // Telefone público (indicado pela IGNIVA).
  phone: "+351 912 174 900",
  phoneHref: "tel:+351912174900",
  // Endereço do Worker que recebe os formulários (no mesmo domínio do site).
  formEndpoint: "/api/enviar",
};
